import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppStore } from '../../store/useAppStore'
import {
  useFavorites,
  useCards,
  useCategories,
  useAddToFavorites,
  useRemoveFromFavorites,
  useContentAccess,
} from '../../hooks/useApi'
import { useFavoritesData } from './hooks/useFavoritesData'
import FavoritesSection from './components/FavoritesSection'
import favoritesEmptyIcon from '../../assets/images/solar_star-line-duotone-active.svg'
import noFavoriteIcon from '../../assets/images/noFavorite.png'
import './FavoritesPage.css'

const FavoritesPage = () => {
  const { favorites, hasActiveSubscription } = useAppStore()
  const navigate = useNavigate()
  const [searchQuery, setSearchQuery] = useState('')

  // Загружаем данные
  const { data: favoritesData, isLoading: favoritesLoading } = useFavorites()
  const { data: cardsData, isLoading: cardsLoading } = useCards()
  const { hasSubscription } = useContentAccess()
  const { data: categoriesData, isLoading: categoriesLoading } =
    useCategories(hasSubscription)

  // API мутации для избранного
  const addToFavoritesMutation = useAddToFavorites()
  const removeFromFavoritesMutation = useRemoveFromFavorites()

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value)
  }

  const clearSearch = () => {
    setSearchQuery('')
  }

  // Функция для переключения избранного с API
  const handleToggleFavorite = async (itemId: string) => {
    const cardId = parseInt(itemId)
    const isFavorite = favorites.includes(itemId)

    try {
      if (isFavorite) {
        await removeFromFavoritesMutation.mutateAsync({ card_id: cardId })
      } else {
        await addToFavoritesMutation.mutateAsync({ card_id: cardId })
      }
    } catch (error) {
      console.error('Ошибка при изменении избранного:', error)
    }
  }

  // Получаем данные избранного
  const { favoriteCards, hierarchicalFavoriteCards } = useFavoritesData({
    cardsData,
    favorites,
    searchQuery,
    categoriesData,
  })

  if (!hasActiveSubscription()) {
    return (
      <div className="favorites-page">
        <div className="favorites-no-subscription">
          <h2 className="favorites-no-subscription-title">Избранное</h2>
          <p className="favorites-no-subscription-text">
            Раздел доступен только для подписчиков
          </p>
          <button
            className="subscribe-button"
            onClick={() => navigate('/subscribe')}
          >
            Оформить подписку
          </button>
        </div>
      </div>
    )
  }

  if (!favoritesLoading && !cardsLoading && favorites.length === 0) {
    return (
      <div className="favorites-page">
        <div className="favorites-empty">
          <img
            src={favoritesEmptyIcon}
            alt="Избранное"
            className="favorites-empty-icon"
            width={48}
            height={48}
          />
          <h2 className="favorites-empty-title">Пока пусто</h2>
          <p className="favorites-empty-text">
            Нажмите на <img src={noFavoriteIcon} alt="избранное" className="favorites-empty-inline-icon" />, чтобы добавить
            продукт в избранное
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="favorites-page">
      <FavoritesSection
        hasActiveSubscription={hasActiveSubscription}
        favorites={favorites}
        favoritesLoading={favoritesLoading}
        cardsLoading={cardsLoading}
        categoriesLoading={categoriesLoading}
        favoriteCards={favoriteCards}
        hierarchicalFavoriteCards={hierarchicalFavoriteCards}
        searchQuery={searchQuery}
        onSearchChange={handleSearchChange}
        onClearSearch={clearSearch}
        onToggleFavorite={handleToggleFavorite}
      />
    </div>
  )
}

export default FavoritesPage
